import styled from 'styled-components';

export const NavigationWrapper = styled.nav`
  a {
    color: white;
  }

  a:hover,
  a:visited,
  a:link,
  a:active {
    text-decoration: none;
  }
`;

export const MenuFred = styled.div`
  top: 0;
  bottom: 0;
  left: -16rem;
  padding: 2rem 0;
  position: absolute;
  width: 20rem;
  height: 100%;
  transition:
    left 2s,
    background-color 2s,
    height 1s;
  z-index: 999;
`;

export const HamburgerBar = styled.div`
  width: 35px;
  height: 2px;
  background-color: black;
  margin: 8px 0;
  transition: 0.4s;
`;

export const HamburgerBar1 = styled(HamburgerBar)``;
export const HamburgerBar2 = styled(HamburgerBar)``;
export const HamburgerBar3 = styled(HamburgerBar)``;

export const MenuUl = styled.ul`
  /* background: rgba(1, 81, 145, 1); */
  padding: 4rem 1rem;
  li {
    margin-bottom: 2rem;
    display: block;
  }
  transition: display 6s;
`;

export const HamburgerPrefixText = styled.div`
  padding-right: 0.5rem;
  color: white;
  display: block;
`;

export const HamburgerContainer = styled.div`
  display: block;
  cursor: pointer;
  z-index: 999999;
  position: absolute;
  right: 1rem;
  top: 0;
  padding: 0.5rem 0;
`;
